import { render, staticRenderFns } from "./ButtonHrefLink.vue?vue&type=template&id=a4487af4&scoped=true&"
import script from "./ButtonHrefLink.vue?vue&type=script&lang=js&"
export * from "./ButtonHrefLink.vue?vue&type=script&lang=js&"
import style0 from "./ButtonHrefLink.vue?vue&type=style&index=0&id=a4487af4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4487af4",
  null
  
)

export default component.exports